import { render, staticRenderFns } from "./HomeEvent.vue?vue&type=template&id=3bba065a&scoped=true&"
import script from "./HomeEvent.vue?vue&type=script&lang=js&"
export * from "./HomeEvent.vue?vue&type=script&lang=js&"
import style0 from "./HomeEvent.vue?vue&type=style&index=0&id=3bba065a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba065a",
  null
  
)

export default component.exports